import { useCertificationProfileActiveTableStore } from '../../store/myTeamTableStateStore';
import CertificationProfileFilters from '../filters/CertificationProfileFilters';
import CertificationProfileActiveTable from './CertificationProfileActiveTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificationProfileActiveTab = ({
  certificationName
}) => {
  const store = useCertificationProfileActiveTableStore();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CertificationProfileFilters, {
      store: store
    }), /*#__PURE__*/_jsx(CertificationProfileActiveTable, {
      certificationName: certificationName
    })]
  });
};
export default CertificationProfileActiveTab;